import { render, staticRenderFns } from "./miniStatsDashboard.vue?vue&type=template&id=53c09494&scoped=true"
import script from "./miniStatsDashboard.vue?vue&type=script&lang=js"
export * from "./miniStatsDashboard.vue?vue&type=script&lang=js"
import style0 from "./miniStatsDashboard.vue?vue&type=style&index=0&id=53c09494&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c09494",
  null
  
)

export default component.exports